// extracted by mini-css-extract-plugin
export var backdropBlur = "_l5-0";
export var contentCard = "_l5-5";
export var frame = "_l5-2";
export var image = "_l5-4";
export var imagePane = "_l5-3";
export var modal = "_l5-1";